import { Observable } from 'rxjs';
import { FusionApiHttpClient } from '../../../../../shared/_services/server-clients';
import type { PublisherTrafficSource, ResponseFromServer } from '../../../../../shared/_models/models';

export class PublisherTrafficSourceApiService {
  constructor(private readonly fusionApiHttpClient: FusionApiHttpClient) {}

  getPublisherTrafficSources(publisherId: number): Observable<PublisherTrafficSource[]> {
    return this.fusionApiHttpClient.plain.get<PublisherTrafficSource[]>(`publisher/${publisherId}/traffic-source`);
  }

  updatePublisherTrafficSources(publisherId: number, body: FormData): Observable<ResponseFromServer<PublisherTrafficSource[]>> {
    return this.fusionApiHttpClient.post<PublisherTrafficSource[], FormData>(`publisher/${publisherId}/traffic-source`, body);
  }
}
